'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require('./styles/Help.css') : void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Help = function Help(props) {

  return _react2.default.createElement(
    'div',
    { className: 'help' },
    _react2.default.createElement(
      'div',
      { className: 'help-intro' },
      _react2.default.createElement(
        'span',
        null,
        'For all your App Center Application questions and issues, they should be directed to the App Center Partner. App Center Partners provide first level support for their integrations with SAP Concur. To contact App Center Partners, please follow these steps:'
      )
    ),
    _react2.default.createElement(
      'p',
      null,
      '1. Go to the Concur App Center: ',
      _react2.default.createElement(
        'a',
        { href: 'https://www.concur.com/app-center' },
        'https://www.concur.com/app-center'
      )
    ),
    _react2.default.createElement(
      'p',
      null,
      '2. Search for the Application you are trying to connect to or are experiencing an issue with (ex: Uber):'
    ),
    _react2.default.createElement('img', { src: !!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require('./styles/images/search.png') : void 0 }),
    _react2.default.createElement(
      'p',
      null,
      '3. Click on the App Center Listing:'
    ),
    _react2.default.createElement('img', { src: !!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require('./styles/images/result.png') : void 0 }),
    _react2.default.createElement(
      'p',
      null,
      '4. Click on the blue "Support" link'
    ),
    _react2.default.createElement('img', { src: !!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require('./styles/images/support_link.png') : void 0 }),
    _react2.default.createElement(
      'div',
      { className: 'help-thank-you' },
      _react2.default.createElement(
        'p',
        null,
        'This will give you the contact information to the App Center Partner. If the App Center Partner needs to work with SAP Concur, they will submit a case on your behalf.'
      ),
      _react2.default.createElement(
        'p',
        null,
        'Thank you,'
      ),
      _react2.default.createElement(
        'p',
        null,
        'Concur Support'
      )
    )
  );
};

exports.default = Help;


//////////////////
// WEBPACK FOOTER
// ./lib/help/Help.js
// module id = 600
// module chunks = 0